
import type { SVGProps } from 'react';
const SvgLanguage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#language_svg__a)">
      <path
        fill="#263E6A"
        d="M12 21.5a9.2 9.2 0 0 1-3.687-.75 9.6 9.6 0 0 1-3.025-2.038 9.6 9.6 0 0 1-2.039-3.024A9.2 9.2 0 0 1 2.5 12q0-1.97.749-3.695a9.7 9.7 0 0 1 2.04-3.017A9.6 9.6 0 0 1 8.312 3.25 9.2 9.2 0 0 1 12 2.5a9.2 9.2 0 0 1 3.695.75 9.7 9.7 0 0 1 3.017 2.038q1.29 1.29 2.039 3.017.75 1.725.749 3.695 0 1.954-.75 3.688a9.6 9.6 0 0 1-2.038 3.024 9.7 9.7 0 0 1-3.017 2.039A9.2 9.2 0 0 1 12 21.5m0-1.521q.765-1.016 1.289-2.048.522-1.033.851-2.258H9.86q.348 1.263.861 2.296.514 1.034 1.279 2.01m-1.937-.275a11 11 0 0 1-1.032-1.876q-.458-1.05-.712-2.155H4.927a7.8 7.8 0 0 0 2.125 2.617 7.14 7.14 0 0 0 3.012 1.414m3.874 0a7.14 7.14 0 0 0 3.011-1.414 7.8 7.8 0 0 0 2.125-2.617h-3.392a16 16 0 0 1-.76 2.164 13 13 0 0 1-.984 1.867m-9.639-5.53h3.717a12 12 0 0 1-.136-1.094 14 14 0 0 1 0-2.16q.043-.535.136-1.093H4.298A8 8 0 0 0 4 12a8 8 0 0 0 .298 2.173m5.217 0h4.97A12.6 12.6 0 0 0 14.664 12q0-.564-.043-1.09a13 13 0 0 0-.136-1.083h-4.97A12.6 12.6 0 0 0 9.336 12q0 .564.043 1.09.043.525.136 1.083m6.47 0h3.717q.144-.51.221-1.06a8 8 0 0 0-.221-3.287h-3.717q.094.558.136 1.093a14 14 0 0 1 0 2.16 13 13 0 0 1-.136 1.093m-.304-5.847h3.392a7.8 7.8 0 0 0-2.11-2.617 7.4 7.4 0 0 0-3.027-1.423 12.4 12.4 0 0 1 1.024 1.91q.448 1.035.72 2.13m-5.821 0h4.28a13 13 0 0 0-.876-2.31A11.7 11.7 0 0 0 12 4.02a11.7 11.7 0 0 0-1.264 1.995 13 13 0 0 0-.876 2.311m-4.933 0h3.392q.274-1.095.721-2.13.449-1.037 1.024-1.91-1.728.382-3.031 1.427a7.9 7.9 0 0 0-2.106 2.613"
      />
    </g>
    <defs>
      <clipPath id="language_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLanguage;
